import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const connectionString = import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: connectionString || '',
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    disableTelemetry: !connectionString,
  },
});

export function initTelemetry(): void {
  if (!connectionString) {
    console.warn(
      '[telemetry] VITE_APPLICATIONINSIGHTS_CONNECTION_STRING not set — telemetry disabled',
    );
    return;
  }

  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

export { reactPlugin, appInsights };
